// The global feedback modal (opened from the navbar pill) posts straight into
// Chatwoot through its public (widget) API. Auth is the non-secret
// inbox_identifier carried in the URL, so there is no backend relay and no
// token in the bundle — see ./_requests.ts.

export type FeedbackType = 'sugestao' | 'problema' | 'elogio' | 'duvida';

export type FeedbackSubmission = {
  type: FeedbackType;
  message: string;
  email?: string;
};

// Identity pulled from the auth context (useAuth().currentUser) so support sees
// who wrote in without asking. All optional — the form still works if a field
// is missing from the session.
export type FeedbackReporter = {
  id?: string;
  name?: string;
  email?: string;
  phone?: string;
  role?: string;
  environmentId?: string;
};

// Where the user was when they opened the feedback modal, captured from the
// router at open time so support sees what the feedback is about without asking.
export type FeedbackContext = {
  page?: string;
};

// PT-BR labels for the <select> values, reused to title the Chatwoot message.
export const FEEDBACK_TYPE_LABELS: Record<FeedbackType, string> = {
  sugestao: 'Sugestão',
  problema: 'Problema',
  elogio: 'Elogio',
  duvida: 'Dúvida',
};

// --- Chatwoot public API responses (only the fields we consume) ---

export type ChatwootPublicContact = {
  source_id: string;
  pubsub_token?: string;
};

export type ChatwootPublicConversation = {
  id: number;
};
